/**
 * /comms → /comms/inbox (Agent U1). The area index just redirects to the inbox
 * (07_UX_UI §1: `/comms` redirects to `/comms/inbox`).
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/comms/')({
  beforeLoad: () => {
    throw redirect({ to: '/comms/inbox' });
  },
});
